import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

export const ConfirmReplaceHomeStateModal = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  currentHomeStateName,
  newHomeStateName,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  currentHomeStateName: string;
  newHomeStateName: string;
}) => {
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="small">
        <StatusModal type="warning" title="Replace home state?">
          This company can only have one home state at a time. Continuing will
          replace {currentHomeStateName} with {newHomeStateName}.
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Button type="button" onClick={onClose} disabled={isLoading}>
            Go back
          </Button>
          <Button
            customType="primary"
            onClick={onConfirm}
            disabled={isLoading}
            isLoading={isLoading}
          >
            Yes, replace
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
